export default __webpack_public_path__ + "static/media/CRISPRHomePageDarkBlue2.93b644d8.jpeg";